import { Link, useParams } from "react-router-dom";

import { LeadActions } from "@/components/LeadActions";
import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { contactDetails, productDetails } from "@/data/siteContent";

export default function ProductDetailPage({ content }) {
  const { slug } = useParams();
  const product = productDetails[content.locale][slug];
  const isHindi = content.locale === "hi";
  const productHighlights = Array.isArray(product?.highlights) ? product.highlights : [];
  const productUseCases = Array.isArray(product?.useCases) ? product.useCases : [];

  if (!product) {
    return (
      <div className="mx-auto max-w-4xl px-4 py-20 text-center sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-semibold text-stone-900" data-testid="product-not-found-title">
          {isHindi ? "उत्पाद नहीं मिला" : "Product not found"}
        </h1>
        <Link to="/products" className="mt-4 inline-flex text-sm font-semibold text-primary" data-testid="product-not-found-link">
          {isHindi ? "उत्पादों पर वापस जाएँ" : "Back to products"}
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[1.05fr_0.95fr]">
        <div className="overflow-hidden rounded-[34px] border border-stone-200 bg-white p-4 shadow-xl shadow-stone-200/60">
          <img src={product.image} alt={product.title} className="aspect-[4/3.6] w-full rounded-[28px] object-cover object-center" data-testid={`product-detail-image-${slug}`} />
        </div>
        <div className="space-y-8">
          <SectionHeading eyebrow={isHindi ? "उत्पाद विवरण" : "Product detail"} title={product.title} description={product.description} />
          <div className="inline-flex rounded-full bg-primary/10 px-4 py-2 text-sm font-semibold text-primary" data-testid="product-detail-fssai-badge">
            FSSAI Licensed
          </div>
          <div className="grid gap-4">
            {productHighlights.map((item, index) => (
              <div key={item} className="rounded-[24px] border border-primary/10 bg-primary/5 px-5 py-4 text-sm font-medium text-stone-700" data-testid={`product-detail-highlight-${index + 1}`}>
                {item}
              </div>
            ))}
          </div>
          <Card className="rounded-[28px] border-stone-200 bg-stone-50">
            <CardContent className="space-y-4 p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-400" data-testid="product-detail-use-cases-title">
                {isHindi ? "उपयोग के मामले" : "Use cases"}
              </p>
              <div className="grid gap-3 sm:grid-cols-2">
                {productUseCases.map((item, index) => (
                  <div key={item} className="rounded-[20px] bg-white px-4 py-4 text-sm font-medium text-stone-700 shadow-sm" data-testid={`product-detail-use-case-${index + 1}`}>
                    {item}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
          <LeadActions labels={content.ctas} contact={contactDetails} prefix={`product-${slug}`} />
        </div>
      </div>
    </div>
  );
}